module.exports = __webpack_public_path__ + "static/img/footer.66f36ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer.png
// module id = or/K
// module chunks = 5